import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MarginSettingState } from "../object/marginSettingState";
import { MarginParams } from "../object/marginParams";

const initialState: MarginSettingState = {
    margin_params: null,
    margin_cabin_mix_apply_eco_first: false,
}

const updateMarginParamsReducer = (state: MarginSettingState, action: PayloadAction<MarginParams | null>): MarginSettingState => ({
    ...state, margin_params: action.payload
});
const updateMarginCabinParamsReducer = (state: MarginSettingState, action: PayloadAction<boolean>): MarginSettingState => ({
    ...state, margin_cabin_mix_apply_eco_first: action.payload
});

export const marginSetting = createSlice({
    name: 'margin_setting',
    initialState,
    reducers: {
        updateMarginParams: updateMarginParamsReducer,
        updateMarginCabinParams: updateMarginCabinParamsReducer
    }
});

export const { updateMarginParams, updateMarginCabinParams } = marginSetting.actions;